var exports = {
  "Qs": "DomainMovedStepsModal.module__content___OUFJbk",
  "Ci": "DomainMovedStepsModal.module__steps___OUFJbk",
  "PM": "DomainMovedStepsModal.module__step___OUFJbk",
};

module.exports = exports;
